/**
 * What a chip actually asks the agent.
 *
 * ⚠ THE CHIP'S `label` IS NOT ITS QUESTION. Every surface was sending `item.label` — the button
 * text — where the service's schema says `prompt`, so the agent received "Spend by vendor" instead
 * of the question that chip exists to ask. `QuickAction` is `{group, label, prompt}` and all three
 * are required (`GET /flows/{flow}/greeting`, agent OpenAPI), so this is not a shape the frontend
 * gets to choose.
 *
 * The `label` fallback is deliberate and is strictly better than the old behaviour: if a stale or
 * partial response ever omits `prompt`, the chip still asks something rather than sending
 * `undefined` and appearing broken.
 *
 * ⚠ TAKES THE WHOLE ACTION, NOT A STRING, so a chip's other fields are read here too instead of being
 * threaded through every surface again — see `quickActionReportId`.
 */
export const quickActionPrompt = (action) => action?.prompt || action?.label || '';

/**
 * The report a chip asks for by id, or null when it asks an ordinary question.
 *
 * A chip naming a `report_id` gets that report rendered server-side (app-agent#289), and its prompt still
 * goes with it as the question the user sees they asked. Anything but a non-empty string counts as no id,
 * so a malformed chip degrades to an ordinary question instead of a message the server refuses.
 */
export const quickActionReportId = (action) => (typeof action?.report_id === 'string' && action.report_id) || null;

export const quickActionHelpers = {
  groupQuickActions: (quickActions) => quickActions.reduce((groups, quickAction) => {
    let group = groups.find((existingGroup) => existingGroup.group === quickAction.group);
    if (!group) {
      group = {group: quickAction.group, items: []};
      groups.push(group);
    }
    group.items.push(quickAction);
    return groups;
  }, []),
};
